import { MoneyLinkException } from "@/shared/utils/custom-exception";
import { ApiClient } from "@/shared/services/api-client";
import { GetTradeJumpInfoRequestModel, GetTradeJumpInfoResponseModel } from "@/features/trade-jump/services/get-trade-jump-info-model";

export class GetTradeJumpInfoApi {
  /**
   * 明細ジャンプ情報取得
   */
  public getTradeJumpInfo = async (
    param: GetTradeJumpInfoRequestModel
  ): Promise<GetTradeJumpInfoResponseModel> => {
    const path = `/api/tradejumpinfo`;
    const res = await ApiClient.instance.get<GetTradeJumpInfoResponseModel>({
      path: path,
      params: param as NonNullable<unknown>,
    });

    if (res.ok === false) {
      throw MoneyLinkException.fromServer({ response: res });
    }

    return res.body;
  };
}
